import React from 'react';
import { connect } from 'react-redux';

import { CardElement } from 'react-stripe-elements';

import { cardElementChange } from '../reducer';

export class CardView extends React.Component {

    onCardChange = (card) => {
        this.props.onCardChange(card);
    }

    render() {
        return (
            <div className="required field">
                {
                    this.props.showHeader &&
                    <label className="card-header">Credit details</label>
                }
                <CardElement className="card-element" id="card"
                    onChange={this.onCardChange}
                    hidePostalCode={true}
                    style={{ base: { fontFamily: "Lato", lineHeight: "1.21428571em", fontSize: "16px" } }}
                />
                {
                    this.props.errorMessage &&
                    <p className="c-error">{this.props.errorMessage}</p>
                }
            </div>
        );
    }
}

const mapState = (state) => {
    return {
        errorMessage: state.donation.cardErrorMessage
    };
};

const mapDispatch = (dispatch, ownProps) => {
    return {
        onCardChange: (card) => {
            dispatch(cardElementChange(card));
        },
    };
};

const Card = connect(mapState, mapDispatch)(CardView);
export default Card;